exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pfe-root[data-v-61d468e4]{position:fixed;inset:0;z-index:200;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.pfe-toolbar[data-v-61d468e4]{position:relative;z-index:2}", ""]);

// exports
